export const actionType = {
  FilterValuesList: 'FilterValuesList',
  SetValuesList: 'SetValuesList',
  SetDate: 'SetDate',
  ApplyConditionalLayout: 'ApplyConditionalLayout'
};
export const aclType = {
  Section: 'Section',
  LayoutItem: 'LayoutItem'
};
export const layoutItemActionType = {
  Display: 'Display',
  ReadOnly: 'ReadOnly',
  Hide: 'Hide',
  Required: 'Required',
  ForceDisplay: 'ForceDisplay'
};
export const sectionLayoutActionType = {
  Display: 'Display',
  ReadOnly: 'ReadOnly',
  Hide: 'Hide',
  ForceDisplay: 'ForceDisplay'
};
export const fieldType = {
  Text: 'TEXT',
  Numeric: 'NUMERIC',
  Date: 'DATE',
  ValuesList: 'VALUES_LIST',
  Attachment: 'ATTACHMENT'
};
export const operatorType = {
  CurrentDay: 'CurrentDay',
  CurrentMonth: 'CurrentMonth',
  CurrentQuarter: 'CurrentQuarter',
  CurrentYear: 'CurrentYear',
  AfterToday: 'AfterToday',
  PriorToToday: 'PriorToToday',
  CurrentHour: 'CurrentHour',
  CurrentMinute: 'CurrentMinute',
  BetweenTime: 'BetweenTime',
  LastXDays: 'LastXDays',
  NextXDays: 'NextXDays',
  LastXMonths: 'LastXMonths',
  NextXMonths: 'NextXMonths',
  LastXQuarters: 'LastXQuarters',
  NextXQuarters: 'NextXQuarters',
  LastXYears: 'LastXYears',
  NextXYears: 'NextXYears',
  LastXHours: 'LastXHours',
  NextXHours: 'NextXHours',
  LastXMinutes: 'LastXMinutes',
  NextXMinutes: 'NextXMinutes',
  DoesNotEqual: 'DoesNotEqual',
  Contains: 'Contains',
  DoesNotContain: 'DoesNotContain',
  Exact: 'Exact',
  GreaterThan: 'GreaterThan',
  LessThan: 'LessThan',
  Equals: 'Equals',
  NotEqual: 'NotEqual',
  Between: 'Between',
  Changed: 'Changed'
};
export const conditionType = {
  Text: 'Text',
  Numeric: 'Numeric',
  NumericBetween: 'NumericBetween',
  NumericRange: 'NumericRange',
  ValueList: 'ValueList',
  DateOffset: 'DateOffset',
  DateComparison: 'DateComparison',
  DateRange: 'DateRange',
  CurrentDate: 'CurrentDate',
  DateTimeRange: 'DateTimeRange',
  ChangedField: 'ChangedField'
};
export const setDateActionType = {
  Offset: 'Offset',
  Specific: 'Specific'
};

export default {
  actionType,
  aclType,
  layoutItemActionType,
  sectionLayoutActionType,
  fieldType,
  operatorType,
  conditionType,
  setDateActionType
};
